<template>
    <div class="d-flex justify-content-between mt-4">
      <button type="button" class="btn btn-primary btn-submit-1 custom-p-2" @click="prev">
        مرحله قبل
      </button>
      <button type="submit" class="btn btn-primary btn-submit-1 custom-p-2" @click="next">
        مرحله بعد
      </button>
    </div>
</template>

<script>
export default {
  methods: {
    next() {
      this.$emit("next");
    },
    prev() {
      this.$emit("prev");
    }
  }
}
</script>